export enum PageNameStepInputNames {
  PageName = 'pageName',
}
